import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { SaleProcessFormNew } from './sale-process-form-new';

export type PermitsDrawerProps = {
  readonly opportunity: any;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly isOpen: boolean;
  readonly formId: string;
};

export function SaleProcessNewDrawer({ opportunity, onSubmit, onClose, isOpen, formId }: PermitsDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Process details')} open={isOpen} onClose={onClose} footer={footer}>
      <SaleProcessFormNew
        id={formId}
        opportunity={opportunity}
        onSubmit={(data: any) => {
          onSubmit(data, t('Process details section has been updated'));
        }}
      />
    </Drawer>
  );
}
